module.exports = __webpack_public_path__ + "static/media/arrowDown.36f712be.svg";